import { useTranslation } from 'react-i18next';

import { ListingCard } from './listing-card';
import { formatEventPrice, localePath } from '../lib/format';
import { formatDateCompact } from '@todo/core/i18n/format';
import { localizedTitle } from '@todo/core/i18n/event-content';
import { useLocale } from '@todo/core/i18n/use-locale';
import type { DbEvent } from '@todo/core/supabase';

// One show (a row of event_shows_filtered: its soonest date in the list's
// window, `date_count` dates in all) as a listing card: the category, the
// date — "+ N more dates" for a recurring show — and the venue as facts, the
// ticket price at the bottom. Links to the show page, /events/<show_slug>.
export function EventCard({ event }: { event: DbEvent }) {
  const { t } = useTranslation();
  const { locale } = useLocale();

  const more = (event.date_count ?? 1) - 1;
  const date = formatDateCompact(event.start_ts, event.tz, locale);
  const facts = [more > 0 ? t('events.card.dateMore', { date, count: more }) : date];
  if (event.venue_name) facts.push(event.venue_name);

  return (
    <ListingCard
      href={localePath(locale, `events/${event.show_slug}`)}
      // Platinumlist's image_big is 960×540; the card box crops it.
      imageUrl={event.image_url}
      category={t(`events.categories.${event.category_id ?? 'other'}`, { defaultValue: t('events.categories.other') })}
      title={localizedTitle(event, locale)}
      facts={facts}
      price={
        event.min_price != null
          ? t('card.from', { price: formatEventPrice(Number(event.min_price), event.currency, locale) })
          : null
      }
    />
  );
}
